import * as React from "react";
import { Form, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Stepper } from "@progress/kendo-react-layout";
import GutterSheet from "./gutter-sheet";
import LFOrder from "./lf-order";
import Intersitial from "./intersitial";
import Uploader from "./uploader";
import useModelStore from "../../store/model-store";

// Define the array of component types rather than pre-rendered elements
const stepComponents = [GutterSheet, LFOrder, Intersitial, Uploader];

export const MultiStepper = ({leadDetail,reload}) => {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
    const { modelData, setModelData,resetModel } = useModelStore();

React.useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  const [step, setStep] = React.useState(0);
  const [formState, setFormState] = React.useState({});
  const [steps, setSteps] = React.useState([
    {
      label: "Gutter Sheet",
    },
    {
      label: "LF Order Sheet",
    },
    {
      label: "Intersitial",
    },
    {
      label: "Picture Uploader",
    },
  ]);
  React.useEffect(() => {
if(!leadDetail.mhalt){
  if (leadDetail.installationDetails?.isCompleted) {
    setStep(3);
  }else if (leadDetail.installationDetailsDraft?.isDraft) {
    setStep(2);
  } else if (leadDetail.gutterSheet && leadDetail.orderSheet) {
    setStep(2);
  } else if(leadDetail.orderSheet){
    setStep(2);
  } else if (leadDetail.gutterSheet || leadDetail.orderSheetDraft) {
    setStep(1);
  } else {
    setStep(modelData.steps);
  }
}else{
  setStep(modelData?.steps)
}
    
  }, [])
  const lastStepIndex = steps.length - 1;
  const isLastStep = lastStepIndex === step;
  const isPreviousStepsValid =
    steps
      .slice(0, step)
      .findIndex((currentStep) => currentStep.isValid === false) === -1;
  
  const onStepSubmit = React.useCallback(
    (event) => {
      if(step==3){
        setModelData({...modelData,open:false,steps:0})
        return
      }
      const { isValid, values } = event;
      const currentSteps = steps.map((currentStep, index) => ({
        ...currentStep,
        isValid: index === step ? isValid : currentStep.isValid,
      }));
      setSteps(currentSteps);
      setStep(() => Math.min(step + 1, lastStepIndex));
      setModelData({...modelData,steps:Math.min(step + 1, lastStepIndex)})
      setFormState(values);
      if (isLastStep && isPreviousStepsValid && isValid) {
        alert(JSON.stringify(values));
      }
    },
    [steps, isLastStep, isPreviousStepsValid, step, lastStepIndex]
  );
  
  const onPrevClick = React.useCallback(
    (event) => {
      event.preventDefault();
      setStep(() => Math.max(step - 1, 0));
    },
    [step, setStep]
  );

  
  
  return (
    <div
    className={isMobile ? 'k-scrollable' : ''}
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
     <div style={{paddingLeft:isMobile ? '10px' : ''}}>
     <Stepper
       orientation={isMobile ? "vertical" : "horizontal"} 
      value={step} items={steps} />
     </div>
      <Form
        initialValues={formState}
        onSubmitClick={onStepSubmit}
        render={(formRenderProps) => {
          // Get the current step component
          const StepComponent = stepComponents[step];
          
          return (
            <div style={{padding:isMobile ? '12px' : "10px 60px"}}>
              <FormElement>
                {/* Render the component with props */}
                <StepComponent nextStep={formRenderProps.onSubmit} leadDetail={leadDetail} isMobile={isMobile} reload={reload}/>
                
                {/* Navigation buttons can be here or in the step components */}
                {/* <span className={"k-form-separator"} />
                <div
                  style={{
                    width:"100%",
                    display: "flex",
                    justifyContent: "end",
                    marginTop:"10px"
                  }}
                >
                  {step !== 0 ? (
                    <Button
                      style={{
                        marginRight: "16px",
                      }}
                      onClick={onPrevClick}
                    >
                      Previous
                    </Button>
                  ) : undefined}
                  <Button
                    className="k-button-green"
                    disabled={isLastStep ? !isPreviousStepsValid : false}
                    onClick={formRenderProps.onSubmit}
                  >
                    {isLastStep ? "Submit" : "Next"}
                  </Button>
                </div> */}
                {
                  leadDetail.mhalt ? 

                   <div
                          className={`k-display-flex k-justify-content-end k-mt-8 ${
                            !isMobile && "k-mb-2"
                          } k-fixed-footer`}
                        >
                   {step !== 0 ?        <Button
                            style={{ width: 130 }}
                            type="button"
                            className="k-mr-2"
                            size={isMobile ? "small" : "large"}
                            onClick={onPrevClick}
                          >
                       Previous                    
                          </Button> : undefined}
                          <Button
                            type="button"
                            style={{ width: "100px" }}
                            primary={true}
                            className="k-button-green k-mr-2"
                            size={isMobile ? "small" : "large"}
                            onClick={formRenderProps.onSubmit}
                          >
                            
                             {step==3 ?  'Done' : 'Next'}
                          </Button>
                        </div>: ''
                }
              </FormElement>
            </div>
          );
        }}
      />
    </div>
  );
};

export default MultiStepper;